import Grid from '../components/grid'
import Container from '../components/ui/container'
import Text from '../components/ui/text'
import { Asset } from '../v2/components/Asset'
import { CMSLink } from '../v2/components/CMSLink'
import { cn } from '@telesoft/lib/web/cn'
import { Asset as AssetT, Page } from '@telesoft/types/payload-types'
import Image from 'next/legacy/image'
import React, { ReactElement } from 'react'

export type PairImageCalloutBlockProps = Extract<
  Page['blocks'][0],
  { blockType: 'pair-image-callout' }
>

export default function PairImageCallout(block: PairImageCalloutBlockProps): ReactElement {
  const { title, description, images, link, options } = block
  return (
    <Container>
      <Grid className="py-8 md:py-12 lg:py-20">
        <div className="col-span-3 md:col-span-6 lg:col-span-5 flex flex-col justify-center items-start">
          <Text variant="subHeading" className="max-w-md text-left">
            {title}
          </Text>
          <Text className="mt-6 max-w-md">{description}</Text>
          <CMSLink {...link} className="mt-10" />
        </div>
        <div className="col-span-full lg:col-span-7">
          <div className="grid grid-cols-2 gap-8">
            <div className="flex justify-center items-center ">
              <div className="relative min-h-[200px] lg:min-h-[500px] w-full border-t border-heading bg-black">
                <div className="absolute z-10 mix-blend-overlay inset-0 bg-gradient-to-tr from-transparent to-telesoft"></div>
                <Asset
                  resource={images![0].image as AssetT}
                  imgClassName={cn(`object-cover object-center`)}
                  fill
                />
              </div>
            </div>
            <div className="flex justify-center items-center ">
              <div className="relative min-h-[200px] lg:min-h-[500px] bottom-12 w-full border-t border-heading bg-black">
                <div className="absolute z-10 mix-blend-overlay inset-0 bg-gradient-to-tr from-transparent to-telesoft"></div>
                <Asset
                  resource={images![1].image as AssetT}
                  imgClassName={cn(`object-cover object-center`)}
                  fill
                />
                {options?.madeInUk && (
                  <div className="absolute -bottom-8 -right-0">
                    <Image width={120} height={24} src="/assets/images/about/uk-manufactured.svg" />
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </Grid>
    </Container>
  )
}
